export const userProfile = function (object) {
  let constraints = {
    first_name: {
      presence: true,
      length: {
        maximum: 20,
      }
    },
    last_name: {
      presence: true,
      length: {
        maximum: 20,
      }
    },
    email: {
      presence: true,
      email: {
        message: '^Email is not valid'
      },
    }
  }

  const countyValidation = {
    county: {
      presence: {
        allowEmpty: false
      }
    }
  };

  const imcValidaiton = {
    imc: {
      presence: {
        allowEmpty: false,
        message: '^GMC Number can\'t  be blank'
      }
    }
  };
  const practiceNameValidaiton = {
    practice_name: {
      presence: {
        allowEmpty: false
      },
      length: {
        maximum: 50,
      }
    }
  };

  const hospitalValidation = {
    hospital: {
      presence: {
        allowEmpty: false
      }
    }
  };

  const registrationValidation = {
    registration: {
      presence: {
        allowEmpty: false,
        message: '^Registration Number can\'t  be blank'
      },
    }
  };

  let roleValidations = {};
  switch (object.user_type) {
    case 'gp':
      roleValidations = { ...imcValidaiton, ...practiceNameValidaiton, ...countyValidation }
      break;
    case 'gp_trainee':
      roleValidations = { ...imcValidaiton, ...practiceNameValidaiton, ...countyValidation }
      break;
    case 'consultant':
      roleValidations = { ...imcValidaiton, ...hospitalValidation }
      break;
    case 'hospital_doctor':
      roleValidations = { ...imcValidaiton }
      break;
    case 'practice_nurse':
      roleValidations = { ...registrationValidation, ...practiceNameValidaiton, ...countyValidation }
      break;
    case 'nurse_specialist':
      roleValidations = { ...registrationValidation, ...imcValidaiton }
      break;
  }
  return { ...constraints, ...roleValidations };
}



/** WEBPACK FOOTER **
 ** ./src/validators/userProfile.js
 **/